<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ref } from '@vue/composition-api';
import { avatarText } from '@core/utils/filter';
import axios from '@/libs/axios';

export default {
  components: {
    BTable,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
      }),
      require: true,
    },

  },
  data() {
    return {
      optionsTipoPessoa:
        [
          {
            tipopessoa: 'Pessoa Fisica',
          },
          {
            tipopessoa: 'Pessoa Juridica',
          },
          {
            tipopessoa: 'Estrangeira',
          },
          {
            tipopessoa: 'Trading',
          },
        ],
      dataFromCondicaoPagamento: null,
    };
  },
  methods: {
    async fetchDataFromCondicaoPagamento() {
      try {
        const response = await axios.get('/condicao-pagamento/');
        this.dataFromCondicaoPagamento = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
  created() {
    this.fetchDataFromCondicaoPagamento();
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  setup() {
    return {
      // Filter
      avatarText,
    };
  },
};
</script>

<template>
  <validation-observer ref="refFormData">
    <div>
      <b-form class="mt-1" @submit.prevent >
        <b-row>
          <b-col
              cols="6"
              class="mb-0"
          >
            <b-form-group
                label="Codigo ERP"
                label-for="clienteiderp"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteiderp"
                    id="clienteiderp"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Codigo do Cliente no ERP"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Sit. Integração"
                label-for="clientesitintegracao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientesitintegracao"
                    id="clientesitintegracao"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Sit. Integração"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Status"
                label-for="clientestatus"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientestatus"
                    id="clientestatus"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Status"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Codigo"
                label-for="clienteid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteid"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteid"
                    id="clienteid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Codigo"
                    disabled
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo de Pessoa"
                label-for="clientetipopessoa"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clientetipopessoa"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.clientetipopessoa"
                    id="clientetipopessoa"
                    :state="errors.length > 0 ? false : null"
                    :options="optionsTipoPessoa"
                    value-field="tipopessoa"
                    text-field="tipopessoa"
                    placeholder="Selecione um tipo de pessoa"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Razão Social"
                label-for="clienterazaosocial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienterazaosocial"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienterazaosocial"
                    id="clienterazaosocial"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Nome Fantasia"
                label-for="clientenomefantasia"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clientenomefantasia"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientenomefantasia"
                    id="clientenomefantasia"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Inscrição Estadual"
                label-for="clienteinscricaoestadual"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteinscricaoestadual"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteinscricaoestadual"
                    id="clienteinscricaoestadual"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Inscrição Estadual"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Inscrição Municipal"
                label-for="clienteinscricaomunicipal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteinscricaomunicipal"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteinscricaomunicipal"
                    id="clienteinscricaomunicipal"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Digite o id"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Codigo Suframa"
                label-for="clientecodigosuframa"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clientecodigosuframa"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clientecodigosuframa"
                    id="clientecodigosuframa"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Codigo Suframa"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="E-mail NFE"
                label-for="clienteemailnfe"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteemailnfe"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteemailnfe"
                    id="clienteemailnfe"
                    :state="errors.length > 0 ? false : null"
                    placeholder="E-mail NFE"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="E-mail Comercial"
                label-for="clienteemailcomercial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteemailcomercial"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.clienteemailcomercial"
                    id="clienteemailcomercial"
                    :state="errors.length > 0 ? false : null"
                    placeholder="E-mail Comercial"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Cond. de Pagamento Descrição"
                label-for="condicaopagamentodescricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="condicaopagamentodescricao"
                  rules="required"
              >
                <b-form-select
                    v-model="dataForm.condicaopagamentodescricao"
                    id="condicaopagamentodescricao"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromCondicaoPagamento"
                    value-field="condicaopagamentoid"
                    text-field="condicaopagamentodescricao"
                    placeholder="Selecione um condiçao pagamento"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Observação"
                label-for="clienteobservacao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="clienteobservacao"
                  rules="required"
              >
                <b-form-textarea
                    v-model="dataForm.clienteobservacao"
                    id="clienteobservacao"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Observação"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </validation-observer>

</template>
